/* global axios */
import ApiClient from '../ApiClient';

// Lista os usuários da conta com Google Agenda conectado (para o nó "Agendar
// reunião" escolher em qual agenda o agente cria os eventos).
class CalendarUsersAPI extends ApiClient {
  constructor() {
    super('google_calendar', { accountScoped: true });
  }

  connectedUsers() {
    return axios.get(`${this.url}/connected_users`);
  }
}

export default new CalendarUsersAPI();
